/*!

=========================================================
* Vision UI Free React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/vision-ui-free-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com/)
* Licensed under MIT (https://github.com/creativetimofficial/vision-ui-free-react/blob/master LICENSE.md)

* Design and Coded by Simmmple & Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

import React, { useEffect, useState, useCallback } from "react"

// @mui material components
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import { Card } from "@mui/material";
import { getUser, setupUser } from 'discordAPI'
import { getFullMemberRows } from 'tableHelper'
import { useHistory } from 'react-router-dom';
import { getAPIToken, getGuilds, getMembersWithDiscord, getAllMembers } from 'GaiaAPI'
import { getValueFromString, calculateSS } from 'Utils'

// Vision UI Dashboard React components
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

// Vision UI Dashboard React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Table from "examples/Tables/Table";
import linearGradient from "assets/theme/functions/linearGradient";

// Vision UI Dashboard React base styles
import colors from "assets/theme/base/colors";

function Dashboard() {
  const { gradients } = colors;
    const history = useHistory();

    const [isComplete, setComplete] = useState([])
    const [guilds, setGuilds] = useState([]);
    const [user, setUser] = useState([]);

    const [allMembers, setAllMembers] = useState([]);

    const [memberRows, setMemberRows] = useState([])


    const [sortModeGuild, setSortModeGuild] = useState('Guild')
    const [sortModeAlliance, setSortModeAlliance] = useState('Power')
    const [top10GuildColumns, setTop10GuildColumns] = useState([])
    const [top10GuildRows, setTop10GuildRows] = useState([])
    const [top10AllianceColumns, setTop10AllianceColumns] = useState([])
    const [top10AllianceRows, setTop10AllianceRows] = useState([])

    const [menuAlliance, setMenuAlliance] = useState(null);

    const openMenuAlliance = ({ currentTarget }) => setMenuAlliance(currentTarget);
    const closeMenuAlliance = () => setMenuAlliance(null);

    const sortbyPower = () => {
        setSortModeAlliance('Power');
        allMembers.sort(function (a, b) {
            if (getValueFromString(a.power) < getValueFromString(b.power))
                return 1;
            if (getValueFromString(a.power) > getValueFromString(b.power))
                return -1;
            return 0;
        });
        setAllianceSearch(allMembers, guilds, 'Power');
        setMenuAlliance(null)
    };
    const sortbySE = () => {
        setSortModeAlliance('Star Expedition');
        allMembers.sort(function (a, b) {
            if (getValueFromString(a.se) < getValueFromString(b.se))
                return 1;
            if (getValueFromString(a.se) > getValueFromString(b.se))
                return -1;
            return 0;
        });
        setAllianceSearch(allMembers, guilds, 'SE Score');
        setMenuAlliance(null)
    };
    const sortbyCCL = () => {
        setSortModeAlliance('CCL');
        allMembers.sort(function (a, b) {
            if (getValueFromString(a.ccl) < getValueFromString(b.ccl))
                return 1;
            if (getValueFromString(a.ccl) > getValueFromString(b.ccl))
                return -1;
            return 0;
        });
        setAllianceSearch(allMembers, guilds, 'CCL');
        setMenuAlliance(null)
    };
    const sortbySS = () => {
        setSortModeAlliance('Stellar Shards');
        allMembers.sort(function (a, b) {
            let valA = calculateSS(a);
            let valB = calculateSS(b);
            if (valA < getValueFromString(valB))
                return 1;
            if (valA > getValueFromString(valB))
                return -1;
            return 0;
        });
        setAllianceSearch(allMembers, guilds, 'SS');
        setMenuAlliance(null)
    };

    const renderMenuAlliance = (
        <Menu
            id="simple-menu"
            anchorEl={menuAlliance}
            anchorOrigin={{
                vertical: "top",
                horizontal: "left",
            }}
            transformOrigin={{
                vertical: "top",
                horizontal: "right",
            }}
            open={Boolean(menuAlliance)}
            onClose={closeMenuAlliance}
        >
            <MenuItem onClick={sortbyPower}>Power</MenuItem>
            <MenuItem onClick={sortbySE}>Star Expedition</MenuItem>
            <MenuItem onClick={sortbyCCL}>CCL</MenuItem>
            <MenuItem onClick={sortbySS}>Stellar Shards</MenuItem>
        </Menu>
    );

    const [menuGuild, setMenuGuild] = useState(null);

    const openMenuGuild = ({ currentTarget }) => setMenuGuild(currentTarget);
    const closeMenuGuild = () => setMenuGuild(null);

    const sortbyGuild = (guild) => {
        setSortModeGuild(guild);
        allMembers.sort(function (a, b) {
            if (getValueFromString(a.se) < getValueFromString(b.se))
                return 1;
            if (getValueFromString(a.se) > getValueFromString(b.se))
                return -1;
            return 0;
        });
        setGuildSearch(allMembers, guilds, guild);
        setMenuGuild(null)
    };

    const renderMenuGuild = (

        <Menu
            id="simple-menu"
            anchorEl={menuGuild}
            anchorOrigin={{
                vertical: "top",
                horizontal: "left",
            }}
            transformOrigin={{
                vertical: "top",
                horizontal: "right",
            }}
            open={Boolean(menuGuild)}
            onClose={closeMenuGuild}
        >
            {
                guilds.map((guild) => (
                    <MenuItem onClick={() => sortbyGuild(guild.name)}>{guild.name}</MenuItem>
                ))
            }
        </Menu>
    );

    const memberColumns = [
        { name: "guild", align: "center" },
        { name: "name", align: "center" },
        { name: "power", align: "center" },
        { name: "power inc", align: "center" },
        { name: "ccl", align: "center" },
        { name: "se score", align: "center" }
    ]

    function setAllianceSearch(searchMembers, myGuilds, sortMode) {
        let gridColumns = [
            { name: "name", align: "center" },
            { name: "guild", align: "center" }
        ]
        gridColumns.push({ name: sortMode.toLowerCase(), align: "center" })
        setTop10AllianceColumns(gridColumns);

        setTop10AllianceRows(getFullMemberRows(memberColumns, searchMembers.filter((m) => m.guild !== 'Ex-Members').slice(0, 10), myGuilds));

    }

    function setGuildSearch(searchMembers, myGuilds, guild) {
        let gridColumns = [
            { name: "name", align: "center" },
            { name: "guild", align: "center" },
            { name: 'se score', align: "center" }
        ]

        setTop10GuildColumns(gridColumns);
        setTop10GuildRows(getFullMemberRows(memberColumns, searchMembers.filter((m) => m.guild === guild).slice(0, 10), myGuilds));

    }

    const getCurrentUser = (accessToken, tokenType) => {
        return new Promise((resolve, reject) => {
            try {
                if (accessToken) {
                    setupUser(accessToken, tokenType)
                        .then((result) => {
                            alert('authorised');
                            resolve(result);
                        },
                            (error) => {
                                reject("User does not have correct role to login");
                            });
                }
                else {
                    getUser()
                        .then((result) => {
                            resolve(result);
                        },
                            (error) => {
                                reject("User does not have correct role to login");
                            });
                }
            } catch (err) {
                reject("User does not have correct role to login");
            }
        });
    }

    const getUserDetails = useCallback(async (accessToken, tokenType) => {
        try {
        getCurrentUser(accessToken, tokenType)
            .then((result) => {
                var curuser = result;
                setUser(result);

                getAPIToken()
                    .then((token) => {
                        getGuilds(token)
                            .then((guildsResult) => {
                                setGuilds(guildsResult);
                                setSortModeGuild(guildsResult[0].name);

                                getMembersWithDiscord(token, curuser.username)
                                    .then((membersResult) => {
                                        setMemberRows(getFullMemberRows(memberColumns, membersResult, guildsResult));

                                        setComplete(true);
                                    },
                                        (error) => {
                                            alert(error);
                                        });

                                getAllMembers(token)
                                    .then((allMembersResult) => {
                                        try {
                                            for (let i = 0; i < allMembersResult.length; i++) {
                                                allMembersResult[i].ss = calculateSS(allMembersResult[i]);
                                            }
                                            allMembersResult.sort(function (a, b) {
                                                if (getValueFromString(a.power) < getValueFromString(b.power))
                                                    return 1;
                                                if (getValueFromString(a.power) > getValueFromString(b.power))
                                                    return -1;
                                                return 0;
                                            });
                                            setAllianceSearch(allMembersResult, guildsResult, 'Power')

                                            allMembersResult.sort(function (a, b) {
                                                if (getValueFromString(a.se) < getValueFromString(b.se))
                                                    return 1;
                                                if (getValueFromString(a.se) > getValueFromString(b.se))
                                                    return -1;
                                                return 0;
                                            });
                                            setGuildSearch(allMembersResult, guildsResult, guildsResult[0].name)

                                            setAllMembers(allMembersResult);
                                        }
                                        catch (error) {
                                            alert(error);
                                        }
                                    },
                                        (error) => {
                                            alert(error);
                                        });
                            },
                                (error) => {
                                    alert(error);
                                });
                    },
                        (error) => {
                            alert('Token failed');
                            alert(error);
                        });
            },
                (error) => {
                history.push('/authentication/sign-in');
                });
        } catch (err) {
            alert(err.message);
        }
    }, []);


    useEffect(() => {
        const fragment = new URLSearchParams(window.location.hash.slice(1));
        const [accessToken, tokenType, expiresin] = [
            fragment.get("access_token"),
            fragment.get("token_type"),
            fragment.get("expires_in")
        ];
        getUserDetails(accessToken, tokenType);
    }, [getUserDetails]);

    if (!isComplete) return null;

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <VuiBox py={3}>
        <VuiBox mb={3}>
          <Grid container spacing="18px">
                      <Grid item xs={12} lg={12} xl={4}>
                          <Card sx={() => ({
                              height: '100%',
                              background: linearGradient(gradients.cardDark.main, gradients.cardDark.state, gradients.cardDark.deg)
                          })}>
                              <VuiBox height="100%" display="flex" flexDirection="column" justifyContent="space-between">
                                  <VuiBox>
                                      <VuiBox>
                                          &nbsp;
                                      </VuiBox>
                                      <VuiTypography color="text" variant="h5" fontWeight="regular" mb="12px">
                                          Welcome back
                                      </VuiTypography>
                                      <VuiTypography color="white" variant="h3" fontWeight="bold" mb="18px">
                                          {user.name}
                                      </VuiTypography>
                                      <VuiTypography color="white" variant="h5" fontWeight="bold" mb="18px">
                                          {user.role}
                                      </VuiTypography>
                                      <VuiTypography color="text" variant="h5" fontWeight="regular" mb="auto">
                                          Glad to see you again!
                                      </VuiTypography>
                                  </VuiBox>
                              </VuiBox>
                          </Card>
            </Grid>
            <Grid item xs={12} lg={12} xl={8}>
                <Card sx={{
                        height: '100%',
                        background: linearGradient(gradients.cardDark.main, gradients.cardDark.state, gradients.cardDark.deg)
                    }}>
                    <VuiBox height="100%" display="flex" flexDirection="column" justifyContent="space-between">
                        <VuiBox>
                            <VuiBox display="flex" justifyContent="space-between" alignItems="center" mb="0px">
                                <VuiTypography variant="lg" color="white">
                                    Accounts
                                </VuiTypography>
                            </VuiBox>
                            <VuiBox
                                sx={{
                                    "& th": {
                                        borderBottom: ({ borders: { borderWidth }, palette: { grey } }) =>
                                            `${borderWidth[1]} solid ${grey[700]}`,
                                    },
                                    "& .MuiTableRow-root:not(:last-child)": {
                                        "& td": {
                                            borderBottom: ({
                                                borders: { borderWidth }, palette: { grey } }) =>
                                                `${borderWidth[1]} solid ${grey[700]}`,
                                        },
                                    },
                                }}
                            >
                                <Table columns={memberColumns} rows={memberRows} />
                            </VuiBox>
                        </VuiBox>
                    </VuiBox>
                </Card>
            </Grid>
          </Grid>
        </VuiBox>
        <VuiBox mb={3}>
          <Grid container spacing={3}>
            <Grid item xs={12} lg={12} xl={6}>
                <Card sx={{
                        height: '100%',
                        background: linearGradient(gradients.cardDark.main, gradients.cardDark.state, gradients.cardDark.deg)
                          }}>

                              <VuiBox display="flex" justifyContent="space-between" alignItems="center" mb="22px">
                                  <VuiTypography variant="lg" color="white">
                                      Top 10 by {sortModeAlliance}
                                  </VuiTypography>

                                  <VuiBox>
                                      <Icon sx={{ cursor: "pointer", color: "#ffffff" }} fontSize="small" onClick={openMenuAlliance}>
                                          filter_alt
                                      </Icon>
                                      <Icon sx={{ cursor: "pointer", color: "#ffffff" }} fontSize="small" onClick={openMenuAlliance}>
                                          arrow_drop_down
                                      </Icon>
                                      {renderMenuAlliance}
                                  </VuiBox>
                              </VuiBox>
                              <VuiBox
                                  sx={{
                                      "& th": {
                                          borderBottom: ({ borders: { borderWidth }, palette: { grey } }) =>
                                              `${borderWidth[1]} solid ${grey[700]}`,
                                      },
                                      "& .MuiTableRow-root:not(:last-child)": {
                                          "& td": {
                                              borderBottom: ({
                                                  borders: { borderWidth }, palette: { grey } }) =>
                                                  `${borderWidth[1]} solid ${grey[700]}`,
                                          },
                                      },
                                  }}
                              >
                                  <Table columns={top10AllianceColumns} rows={top10AllianceRows} />
                              </VuiBox>
                </Card>
                      </Grid>
                      <Grid item xs={12} lg={12} xl={6}>
                          <Card sx={{
                              height: '100%',
                              background: linearGradient(gradients.cardDark.main, gradients.cardDark.state, gradients.cardDark.deg)
                          }}>
                              <VuiBox display="flex" justifyContent="space-between" alignItems="center" mb="22px">
                                  <VuiTypography variant="lg" color="white">
                                      Top 10 SE for {sortModeGuild}
                                  </VuiTypography>

                                  <VuiBox>
                                      <Icon sx={{ cursor: "pointer", color: "#ffffff" }} fontSize="small" onClick={openMenuGuild}>
                                          filter_alt
                                      </Icon>
                                      <Icon sx={{ cursor: "pointer", color: "#ffffff" }} fontSize="small" onClick={openMenuGuild}>
                                          arrow_drop_down
                                      </Icon>
                                      {renderMenuGuild}
                                  </VuiBox>
                              </VuiBox>
                              <VuiBox
                                  sx={{
                                      "& th": {
                                          borderBottom: ({ borders: { borderWidth }, palette: { grey } }) =>
                                              `${borderWidth[1]} solid ${grey[700]}`,
                                      },
                                      "& .MuiTableRow-root:not(:last-child)": {
                                          "& td": {
                                              borderBottom: ({
                                                  borders: { borderWidth }, palette: { grey } }) =>
                                                  `${borderWidth[1]} solid ${grey[700]}`,
                                          },
                                      },
                                  }}
                              >
                                  <Table columns={top10GuildColumns} rows={top10GuildRows} />
                              </VuiBox>
                          </Card>
                      </Grid>
          </Grid>
        </VuiBox>
      </VuiBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Dashboard;
